$(document).ready(function(){
    setTimeout(function(){
        $('.Collection_hero_outer').addClass('loaded');
        $('.Collection_product_container').addClass('loaded');
    },500);


    $('.Collection_filter_toggle').click(function(){
        $(this).toggleClass('filter_active');
        if ($(window).width() < 960) {
          $('.Collection_filter_cell').toggleClass('MobileVisible');
        }
        else{
          $('.Collection_filter_cell').toggle();
        }
        $('.Collection_main_cell').toggleClass('filter_hidden');
        $('.Main_collection_product_grid').toggleClass('filter_hidden');
    });

    const $rangeSlider = $('#rangeSlider');
    
    $rangeSlider.ionRangeSlider({
      type: 'double',
      grid: true,
      min: 0,
      max: 300.00,
      from: 0,
      to: 300,
      step: 1,
      prefix: '€',
      onStart: updateValues,
      onChange: updateValues,
    });

    function updateValues(data) {
      const minValue = data.from;
      const maxValue = data.to;


      filterByPrice(minValue, maxValue);
    }

    function filterByPrice(minValue, maxValue){
      // console.log('Min Value:', minValue);
      // console.log('Max Value:', maxValue);
      $('.Collection_product_card').removeClass('priceVisible');
      $('.Collection_product_card').each(function(){
        var dataPrice = parseFloat($(this).attr('data-price'))/100;
        if (dataPrice >= minValue && dataPrice <= maxValue){
          $(this).addClass('priceVisible');
        }
      });
        filterItems();
    }

    $('.Collection_filtering_color_select').click(function(){
      if ($(this).hasClass('active')){
        $('.Collection_filtering_color_select').removeClass('active');
        $('.Collection_product_card').addClass('colorVisible');
      }
      else{
        $('.Collection_filtering_color_select').removeClass('active');
        $(this).addClass('active')
        var value = $(this).attr('data');
        $('.Collection_product_card').removeClass('colorVisible');
        $('.Collection_product_card').each(function(){
          if ($(this).attr('data-color') == value){
            $(this).addClass('colorVisible');
          }
        });
      }
      

      filterItems();

    });

    $('.Filter_button_main').click(function(){
      $('.Collection_filter_cell').removeClass('MobileVisible');
      $('.Collection_filter_toggle').removeClass('filter_active');
    });

    $('.Collection_filter_close').click(function(){
      $('.Collection_filter_cell').removeClass('MobileVisible');
      $('.Collection_filter_toggle').removeClass('filter_active');
    });

    $('.Collection_filtering_size_select').click(function(){
      if ($(this).hasClass('active')){
        $(this).removeClass('active');
        $('.Collection_product_card').addClass('variantVisible');
      }
      else{
        $('.Collection_filtering_size_select').removeClass('active');
        $(this).addClass('active');
        var currentValue = $(this).attr('data-title');
  
        console.log(currentValue, 'CURRENT VALUES');
  
        $('.Collection_product_card').removeClass('variantVisible');
        $('.Collection_product_card_btn').removeClass('active');
        $('.Collection_product_card_btn').each(function(){
          if ($(this).attr('data-title') == currentValue){
            // $(this).addClass('active');
            $(this).trigger('click');
            $(this).closest('.Collection_product_card').addClass('variantVisible');
          }
        });
      }
      filterItems();
      
    });



    function filterItems(){
      $('.Content_for_loader_of_col').css('display', 'flex');

      if ($(window).width() > 900) {
        $('.Main_collection_grid_out').hide();
      }
      
      $('.Collection_product_card').hide();
      $('.Collection_product_card.priceVisible.colorVisible.variantVisible').each(function(){
        $(this).show();
      });
      setTimeout(function(){
        $('.Content_for_loader_of_col').hide();
        $('.Main_collection_grid_out').css('display', 'flex');
      },1000);

    }


  $(document).on("click",".Collection_product_card_btn",function() {
      $(this).closest('.Collection_product_card_size_selector').find('.Collection_product_card_btn').removeClass('active');
      $(this).addClass('active');

      var currentSizeTitle = $(this).closest('.Collection_product_card').find('.Collection_product_card_btn.active').attr('data-title');
      var currentColorTitle = $(this).closest('.Collection_product_card').attr('data-color');

      var fullTitle = currentColorTitle + '-' + currentSizeTitle;
      var currentId;

      $(this).closest('.Collection_product_card').find('.Collection_product_card_variant_checker_js').each(function(){
        if ($(this).attr('data-title') == fullTitle){
          currentId = $(this).attr('data-id');
        }
      });

    console.log(currentId, fullTitle, 'CHECKING TO INSPECT');
      
      var currentInv = 0;
      $(this).closest('.Collection_product_card').find('.Collection_product_card_price').hide();
      $(this).closest('.Collection_product_card').find('.Collection_product_card_price').each(function(){
        if ($(this).attr('data-id') == currentId){
          $(this).show();
          currentInv = $(this).attr('data-inv');
        }
      });

    console.log(currentInv, 'CURRENT INVENTORY');

      if (currentInv > 0){
        $(this).closest('.Collection_product_card').find('.Collection_product_card_atc_btn').find('.collection_atc_btn_text').text('Add to cart');
        $(this).closest('.Collection_product_card').find('.Collection_product_card_atc_btn').removeClass('disabled');
      }
      else{
        $(this).closest('.Collection_product_card').find('.Collection_product_card_atc_btn').find('.collection_atc_btn_text').text('Sold out');
        $(this).closest('.Collection_product_card').find('.Collection_product_card_atc_btn').addClass('disabled');
      }

      console.log(currentInv, 'current inventory is');
      
    });

    $('.Collection_product_card').mouseover(function(){

      $('.Collection_product_card').removeClass('active');
      $(this).addClass('active');

    });
    $('.Collection_product_card').mouseout(function(){
      $('.Collection_product_card').removeClass('active');
    });

    $('.Clear_filters').click(function(){
      $('.Collection_filtering_color_select').removeClass('active');
      $('.Collection_filtering_size_select').removeClass('active');
      $('.Collection_product_card').addClass('variantVisible');
      $('.Collection_product_card').addClass('colorVisible');
      $('.Collection_product_card').addClass('priceVisible');
      var slider = $("#rangeSlider").data("ionRangeSlider");
      slider.reset();
      filterItems();
      if ($(window).width() > 900) {
        $('html, body').animate({
            scrollTop: $(".Collection_top_bar_outer").offset().top
        }, 500);
      }
      if ($(window).width() < 900) {
        $('.Collection_filter_cell').removeClass('MobileVisible');
        $('.Collection_filter_toggle').removeClass('filter_active');
      }
     
    });


    // Sorting option
  $('.Filter_sorting_opt').click(function(){
    $('.Filter_sorting_opt').removeClass('active');
    $(this).addClass('active');

    var mode = $(this).attr('data');
    if (mode == 'sortab'){
      console.log('here');
      sortAlpha();
    }
    else if (mode == 'sortba'){
      sortAlphaReverse();
    }
    else if ( mode == 'sortpop'){
      sortPopular();
    }
    filterItems();
  });

  function sortAlpha() {
      var CollectionArray = [];
      var TitlesArray = [];
      var index = 0;

      $('.Collection_product_card').each(function () {
          var currentHtml = $(this).html();
          var currentTitle = $(this).find('.Collection_product_card_title').text();
          TitlesArray.push({ name: currentTitle, index: index });
          CollectionArray.push({ content: currentHtml, index: index});
          index = index += 1;
      });

      TitlesArray.sort(function (a, b) {
          // Use localeCompare for case-insensitive alphabetical sorting
          return a.name.localeCompare(b.name);
      });

      // console.log(TitlesArray, 'LENGTH');

      var collectionItems = [];

      for (var i = 0; i< TitlesArray.length; i++){
        var neededIndex = TitlesArray[i].index;
        // console.log(neededIndex, 'NEEDED INDEX IS THIS');
        for ( var j = 0; j < TitlesArray.length; j++){
          if (CollectionArray[j].index == neededIndex){
            // console.log('THIS HTML CORRECT');
            collectionItems[i] = CollectionArray[j].content;
          }
        }
      }
      // console.log(collectionItems, 'COLLECTION ARRAY');
      
      var indexing = 0;
      $('.Collection_product_card').each(function(){
        var cardHtml;
        cardHtml = collectionItems[indexing];
        $(this).html(cardHtml);
        indexing ++;
      });
  }

  function sortAlphaReverse() {
    var CollectionArray = [];
    var TitlesArray = [];
    var index = 0;

    $('.Collection_product_card').each(function () {
        var currentHtml = $(this).html();
        var currentTitle = $(this).find('.Collection_product_card_title').text();
        TitlesArray.push({ name: currentTitle, index: index });
        CollectionArray.push({ content: currentHtml, index: index});
        index = index += 1;
    });

      TitlesArray.sort(function (a, b) {
          // Use localeCompare for case-insensitive reverse alphabetical sorting
          return b.name.localeCompare(a.name);
      });

    // console.log(TitlesArray, 'LENGTH');

    var collectionItems = [];

    for (var i = 0; i< TitlesArray.length; i++){
      var neededIndex = TitlesArray[i].index;
      // console.log(neededIndex, 'NEEDED INDEX IS THIS');
      for ( var j = 0; j < TitlesArray.length; j++){
        if (CollectionArray[j].index == neededIndex){
          // console.log('THIS HTML CORRECT');
          collectionItems[i] = CollectionArray[j].content;
        }
      }
    }
    // console.log(collectionItems, 'COLLECTION ARRAY');
    
    var indexing = 0;
    $('.Collection_product_card').each(function(){
      var cardHtml;
      cardHtml = collectionItems[indexing];
      $(this).html(cardHtml);
      indexing ++;
    });
  }

  function sortPopular(){
    var originalHtml = $('.Sorting_variable').attr('data-org-html');
    $('.Main_collection_product_grid').html(originalHtml);
  }


  function preloadVariables(){
    var currentHtml  = $('.Main_collection_product_grid').html();
    $('.Sorting_variable').attr('data-org-html', currentHtml);
  }

  preloadVariables();


  $('.col_prod_btn_outer_more a').click(function(evt){
    evt.preventDefault();
    $(this).closest('.Main_coll_outer_full').find('.Collection_product_card').removeClass('hided_before_load')
    $(this).hide();
  });

});